/**
 * Get the number of pixels in relation to the first call.  This can be used to set the "left" of an item in the timeline
 * @param itemDate
 * @param firstCallDate
 * @param secondsPerPixel
 * @returns {number}
 */
export function calculatePosition(itemDate, firstCallDate, secondsPerPixel) {
  return itemDate.diff(firstCallDate, 'seconds') / secondsPerPixel;
}

/**
 * convert the duration to pixels
 * @param duration
 * @param secondsPerPixel
 * @returns {number}
 */
export function calculateWidth(duration, secondsPerPixel) {
  return duration / secondsPerPixel;
}

/**
 * given the width calculate the number of pixels in the one hour block
 * @returns {number}
 */
export function calculateSecondsPerPixel(block_width) {
  return (60 * 60) / block_width;
}

/**
 * number of hours between two dates
 * @param startDate
 * @param endDate
 * @param minHours   to make things look pretty lets have a minimum number of blocks to render
 * @returns {*|void|number}
 */
export function calculateNumHours(startDate, endDate, minHours = 4) {
  return Math.max(minHours, endDate.diff(startDate, 'hours'));
}
